import { Injectable } from '@angular/core';
import { AnalyticsEventGlobalProperties } from 'src/app/core/services/analytics/models/analytics-event-global-properties.model';
import {
  ClientProperties,
  InitiatedByProperties,
  SpProperties,
} from 'src/app/pages/agreements/types/agreement-analytics-properties.model';
import { Agreement } from 'src/app/shared/models/gql/agreement.model';

export const CLIENT_AGREEMENT_EVENT_OBJECT_TARGETS = {
  review: 'Terminate agreement prompt leave review button',
  dismiss: 'Terminate agreement prompt dismiss button',
  back: 'Terminate agreement prompt back button',
} as const;

@Injectable({
  providedIn: 'root',
})
export class AgreementAnalyticsPropertiesService {
  /**
   * The SP related properties for the agreement analytics.
   *
   * @param agreement - The Agreement.
   */
  spProperties(agreement: Agreement): SpProperties {
    return {
      sp_uuid: agreement.otherUser.uuid,
      job_uuid: agreement.job?.uuid,
      agreement_uuid: agreement.uuid,
    };
  }

  /**
   * The client related properties for the agreement analytics.
   *
   * @param clientUuid - The UUID of the client.
   * @param jobUuid - The ID of the job (optional).
   * @param agreementUuid - The ID of the agreement.
   */
  clientProperties(clientUuid: string, jobUuid: string | undefined, agreementUuid: string): ClientProperties {
    return {
      client_uuid: clientUuid,
      job_uuid: jobUuid,
      agreement_uuid: agreementUuid,
    };
  }

  /**
   * The related properties for the agreement analytics.
   *
   * @param clientUuid - The UUID of the client.
   * @param agreementUuid - The ID of the agreement.
   * @param jobUuid - The ID of the job.
   * @param spUuid - The UUID of the service provider.
   * @param initiatedByUserType - The type of user initiating the agreement.
   */
  initiatedByProperties(
    clientUuid: string,
    agreementUuid: string | undefined,
    jobUuid: string | undefined,
    spUuid: string,
    initiatedByUserType?: string | undefined,
  ): InitiatedByProperties {
    return {
      client_uuid: clientUuid,
      agreement_uuid: agreementUuid,
      job_uuid: jobUuid,
      sp_uuid: spUuid,
      initiated_by_user_type: initiatedByUserType,
    };
  }

  getAgreementTerminationPromptEventProperties(reason: 'review' | 'dismiss' | 'back'): AnalyticsEventGlobalProperties {
    return {
      object_target: CLIENT_AGREEMENT_EVENT_OBJECT_TARGETS[reason],
      object_type: 'Button',
    };
  }
}
